import './accordions'
import './forms'
import './buttons'
import './gallery'
import './header'
import './slidebars'
import './images'
import './menu-accessibility'



// WEBPACK FOOTER //
// ./public/assets/js/src/components/all.js